module.exports = __webpack_public_path__ + "img/back.5265889c.png";